import React from 'react';
import { FileText, Wrench } from 'lucide-react';
import { Card, CardContent } from '@plvplus/core';

export const FactPlusRedirect: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Module FACT+
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Gestion des devis et facturation
        </p>
      </div>

      <Card variant="elevated" className="max-w-md mx-auto">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Wrench className="h-8 w-8 text-orange-600 dark:text-orange-400" />
          </div>
          
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            En développement
          </h3>
          
          <p className="text-gray-600 dark:text-gray-400">
            Le module FACT+ est actuellement en cours de développement. 
            Il sera bientôt disponible pour gérer vos devis et factures.
          </p>

          <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
            <FileText className="h-6 w-6 text-blue-600 dark:text-blue-400 mx-auto mb-2" />
            <p className="text-sm text-blue-800 dark:text-blue-300">
              Fonctionnalités prévues :
            </p>
            <ul className="text-xs text-blue-700 dark:text-blue-400 mt-2 space-y-1">
              <li>• Génération de devis</li>
              <li>• Facturation automatique</li>
              <li>• Suivi des paiements</li>
              <li>• Relances clients</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
